import React, { useState, useEffect } from "react";
import { PageTitle } from "./pageTitle";
import JsonData from "../data/data.json";
import "../App.css";
import { BodyContrato } from "./bodycontrato";


const ContratoPF = () => {
    const [landingPageData, setLandingPageData] = useState({});
    useEffect(() => {
        setLandingPageData(JsonData);
    }, []);

    return (
        <main className="inner-page inner-page--legal">
        <PageTitle title="Contrato pessoa física" />
        <BodyContrato data={landingPageData.About} contact={landingPageData.Contact}/>
        </main>
    )
};

export default ContratoPF